<template>
    <div class="xh-svh bg-dark-tp">
        <div class="xh-svh max-w-full sm:max-w-md flex flex-col justify-end mx-auto inset-y-0 right-0 py-5 border-r-0 sm:border-r border-l-0 sm:border-l border-gray-900 font-satoshi_r bg-award">

            <div class="pb-80 font-satoshi_r">
                <div class="flex flex-col justify-end items-center px-4 sm:px-6">

                    <div class="">
                        <div class="flex justify-center items-center spinner-bg rounded-full w-12 h-12 mb-5">
                            <img src="@/assets/images/trendupp/Check.svg" alt="">
                        </div>

                        <h1 class="text-1xl font-medium text-cream-500 mb-3">
                            Thank You For Voting!
                        </h1>
                        <p class="text-base font-medium text-gray-x10 pr-6">
                            Your vote has been successfully submitted. Thank you for your time. Please return to the app by using the close button at the top of your screen.
                        </p>
                    </div>

                    <!-- <div class="w-full px-3"> pb-64 sm:pb-72
                        <a 
                            href="https://sphinx.sycamore.ng/public/dashboard/16c193e1-771e-4a51-bb18-e7134b550a15" 
                            class="button is-primary is-medium is-fullwidth font-satoshi_r mt-20"
                        >
                            <span class="text-sm">View leaderboard</span>
                        </a>
                    </div> -->
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: "TrendUppRedirect",

        components: {
        },

        data() {
            return {
            }
        },

        methods: {
            verifyUserStatus() {
                if (!this.$route.query?.status) {
                    this.$router.push({ 
                        path: '/trendupp/vote', 
                        query: { 
                            id: this.$route.query?.id,
                        } 
                    })
                }
            },
        },

        mounted() {
            this.verifyUserStatus();
        },
    };
</script>

<style scoped>
    body {
        background-color: #000000;
    }

    .xh-svh {
        height: 100vh;
        height: 100svh !important;
    }

    .text-1xl {
        font-size: 1.375rem /* 22px */ ;
        line-height: 2rem /* 32px */ ;
    }

    .bg-award {
        background-image: url("../../assets/images/trendupp/awards_01.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center bottom;
    }

    .spinner-bg {
		background: linear-gradient(0deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.06) 100%), #0C0C0C;
	}

    .button {
        border-radius: 12px !important;
    }
</style>

